import cx from 'classnames'

import ButtonWithTooltip from 'common/components/ButtonWithTooltip'
import { Logs as LogsIcon, Notebook as NotebookIcon } from 'common/icons'
import {
  getContentHasVariants,
  getElementHasVariants,
  getIsOptimized,
} from 'features/unifiedFlow/contentPage/helpers'
import {
  useContent,
  useSelectedElement,
} from 'features/unifiedFlow/contentPage/hooks'

import ExportMenuButton from '../../components/layout/components/ExportMenuButton'

import { ActivePanel, HandleActivePanelChange } from './RightSection'

type Props = {
  activePanel: ActivePanel | undefined
  showInputResultsButton: boolean
  onInputResultsClick: () => void
  handleActivePanelChange: HandleActivePanelChange
}

const CollapsedIcons = ({
  activePanel,
  showInputResultsButton,
  onInputResultsClick,
  handleActivePanelChange,
}: Props) => {
  const { content } = useContent()
  const { data: selectedElement } = useSelectedElement()
  const isOptimized = getIsOptimized(selectedElement)

  const commonClassName = 'cursor-pointer hover:text-gold-700'
  const hasVariants = getContentHasVariants(content)
  const hasElementVariants = getElementHasVariants(selectedElement)

  return (
    <>
      {selectedElement && hasVariants && (
        <div className="flex items-stretch">
          <ExportMenuButton tooltipPlacement="top" />
        </div>
      )}
      {showInputResultsButton && isOptimized && hasElementVariants && (
        <ButtonWithTooltip
          data-testid="input-results-button"
          variant="icon"
          tooltip
          tooltipText="Input Results"
          placement="top"
          prefixIcon={
            <NotebookIcon
              size={6}
              isDefaultColor={false}
              className={cx(commonClassName, 'text-gold-600')}
            />
          }
          onClick={onInputResultsClick}
        />
      )}
      {isOptimized && hasElementVariants && (
        <ButtonWithTooltip
          data-testid="logs-sidebar-button"
          variant="icon"
          tooltip
          tooltipText="Logs"
          placement="top"
          prefixIcon={
            <LogsIcon
              size={6}
              isDefaultColor={false}
              className={cx(commonClassName, {
                'text-base-700': activePanel === 'logs',
                'text-gold-600 ': activePanel !== 'logs',
              })}
            />
          }
          onClick={() => handleActivePanelChange('logs')}
        />
      )}
    </>
  )
}

export default CollapsedIcons
